var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-row"},[_c('colored-svg',{staticClass:"flower",attrs:{"color":_vm.flowerColor,"svg-src":"/images/shapes/rounded-eight-points-star.svg"}}),_vm._v(" "),_c('span',{staticClass:"ri-body"},[_vm._v(_vm._s(_vm.text))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }